import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthTokenService } from './auth-token.service';
import { RUNTIME_CONFIG } from './runtime-config';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const cfg = inject(RUNTIME_CONFIG);
    const token = inject(AuthTokenService).token;
    const isBackend =
        req.url.startsWith(cfg.apiBaseUrl) || req.url.startsWith(cfg.compositionApiBaseUrl);
    if (token && isBackend && !req.headers.has('Authorization')) {
        req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
    }
    return next(req);
};
